"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _withOnDemandTranslationProps = require("./withOnDemandTranslationProps");

var _phrase = _interopRequireDefault(require("@insided/deprecated-libs/translationsUtils/phrase"));

var _insidedDataStorage = require("@insided/shared/utils/insidedDataStorage");

var _dropdown = _interopRequireWildcard(require("@insided/deprecated-preact-components/design-system-components/dropdown"));

var _common = require("@insided/shared/utils/common");

var _ChevronDown = _interopRequireDefault(require("@insided/shared/icons/ChevronDown"));

var _LoadingSpinnerV = _interopRequireDefault(require("@insided/shared/icons/LoadingSpinnerV3"));

var _AiStarsV = _interopRequireDefault(require("@insided/shared/icons/AiStarsV2"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

// eslint-disable-next-line no-restricted-imports
var openLoginPopup = function openLoginPopup() {
  if (!(0, _insidedDataStorage.getInsidedData)('user').userid) {
    var event = new window.CustomEvent('GuestUserAction');
    window.dispatchEvent(event);
  }
};

var OnDemandTranslationTrigger = function OnDemandTranslationTrigger(_ref) {
  var isTranslateAll = _ref.isTranslateAll;
  return (0, _preact.h)("div", {
    className: "language-selector-trigger"
  }, isTranslateAll ? (0, _preact.h)(_phrase.default, {
    p: "translate.all"
  }) : (0, _preact.h)(_phrase.default, {
    p: "on.demand.translations.translate"
  }), (0, _preact.h)(_ChevronDown.default, {
    width: 18,
    height: 16
  }));
};

var OnDemandTranslationButton = function OnDemandTranslationButton(_ref2) {
  var languageList = _ref2.languageList,
      isTranslationInProgress = _ref2.isTranslationInProgress,
      isTranslationInProgressForReply = _ref2.isTranslationInProgressForReply,
      isTranslationFailed = _ref2.isTranslationFailed,
      isTranslationFailedForReply = _ref2.isTranslationFailedForReply,
      isPostTranslated = _ref2.isPostTranslated,
      isPostTranslatedForReply = _ref2.isPostTranslatedForReply,
      onDemandTranslation = _ref2.onDemandTranslation,
      onDisplayOriginal = _ref2.onDisplayOriginal,
      selectedLanguageToTranslate = _ref2.selectedLanguageToTranslate,
      isTranslateAll = _ref2.isTranslateAll;
  var languageNames = Object.values(languageList).sort(function (firstElem, nextElem) {
    return firstElem.localeCompare(nextElem);
  });

  var onDemandTranslationFlagEnabled = _common.common.isModuleActive('onDemandTranslations');

  if (!onDemandTranslationFlagEnabled || !languageNames.length) {
    return null;
  }

  var children = null;

  if (isTranslationInProgress || isTranslationInProgressForReply) {
    children = (0, _preact.h)("span", {
      className: "language-selector-trigger on-demand-translation--loader"
    }, (0, _preact.h)(_LoadingSpinnerV.default, {
      width: 18,
      height: 18,
      className: "on-demand-translation--icon icon-loading-spinner",
      fill: "inherit",
      role: "presentation"
    }), (0, _preact.h)(_phrase.default, {
      p: "translating"
    }));
  } else if (isTranslationFailed || isTranslationFailedForReply) {
    children = (0, _preact.h)("ul", {
      className: "list list--dot-seperated"
    }, (0, _preact.h)("li", {
      className: "list-item--no-dot on-demand-translation--failure"
    }, (0, _preact.h)(_phrase.default, {
      p: "on.demand.translation.failed"
    })), (0, _preact.h)("li", null, (0, _preact.h)("span", {
      tabIndex: 1,
      className: "display-as-link",
      role: "button",
      onKeyDown: function onKeyDown(event) {
        if (event.key === 'Enter' || event.key === 'Space') {
          onDemandTranslation(selectedLanguageToTranslate !== null && selectedLanguageToTranslate !== void 0 ? selectedLanguageToTranslate : 'English');
        }
      },
      onClick: /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return onDemandTranslation(selectedLanguageToTranslate !== null && selectedLanguageToTranslate !== void 0 ? selectedLanguageToTranslate : 'English');

              case 2:
                return _context.abrupt("return", _context.sent);

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))
    }, (0, _preact.h)(_phrase.default, {
      p: "on.demand.translation.retry"
    }))));
  } else if (isPostTranslated || isPostTranslatedForReply) {
    children = (0, _preact.h)("div", {
      className: "hubai_on-demand-translation--translated-wrapper"
    }, (0, _preact.h)("div", {
      className: "hubai_on-demand-translation--show-original",
      role: "button",
      tabIndex: 0,
      onKeyDown: function onKeyDown(e) {
        if (e.key === 'Enter') onDisplayOriginal();
      },
      onClick: onDisplayOriginal
    }, (0, _preact.h)(_phrase.default, {
      p: "hub_ai.on.demand.translations.show.original"
    })), (0, _preact.h)("div", {
      className: "post--translated-claimer"
    }, (0, _preact.h)(_AiStarsV.default, {
      width: 18,
      height: 18,
      role: "presentation"
    }), (0, _preact.h)(_phrase.default, {
      p: "translated.by.ai"
    })));
  } else {
    children = (0, _preact.h)("div", {
      className: "on-demand-translation-selection-container"
    }, !(0, _insidedDataStorage.getInsidedData)('user').userid ? (0, _preact.h)("div", {
      style: {
        cursor: 'pointer'
      },
      tabIndex: 0,
      role: "button",
      onKeyDown: function onKeyDown(e) {
        if (e.key === 'Enter') openLoginPopup();
      },
      onClick: function onClick() {
        return openLoginPopup();
      }
    }, (0, _preact.h)(OnDemandTranslationTrigger, {
      isTranslateAll: isTranslateAll
    })) : (0, _preact.h)(_dropdown.default, {
      size: "full-width",
      align: "left",
      position: "bottom",
      trigger: (0, _preact.h)(OnDemandTranslationTrigger, {
        isTranslateAll: isTranslateAll
      }),
      popupName: "language-selector-dropdown",
      closeOnDropdownClick: true
    }, languageNames.map(function (lang) {
      return (0, _preact.h)(_dropdown.DropdownItem, {
        key: lang,
        onClick: /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
          return _regenerator.default.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _context2.next = 2;
                  return onDemandTranslation(lang);

                case 2:
                  return _context2.abrupt("return", _context2.sent);

                case 3:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }))
      }, (0, _preact.h)("div", null, (0, _preact.h)("div", {
        className: "language-item"
      }, lang)));
    })));
  }

  return (0, _preact.h)("div", {
    className: "on-demand-translation-wrapper",
    "aria-live": "polite",
    "aria-busy": isTranslationInProgress
  }, children);
}; // Export the component wrapped with the HOC, selecting all translation-related props


var _default = (0, _withOnDemandTranslationProps.withOnDemandTranslationProps)(OnDemandTranslationButton, ['languageList', 'isTranslationInProgress', 'isTranslationInProgressForReply', 'selectedLanguageToTranslate', 'isTranslationFailed', 'isTranslationFailedForReply', 'isPostTranslated', 'isPostTranslatedForReply', 'onDemandTranslation', 'onDisplayOriginal']);

exports.default = _default;